
import axios from 'axios';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { PayWithdrawal } from '../../../api/api';
import CheckoutNavbar from './components/CheckoutNavbar';
import { toast } from 'react-toastify';

const RejectRequest = () => {

     const [loading, setLoading] = useState(false)

     const params = useParams()



     const handleSubmitForm = async (e) => {
          e.preventDefault()
          const putData = {
               withdrawalType: 3,
               description: e.target.rejectDetail.value,
               // payDate: dateVal,
               // trackingCode: e.target.payCode.value,
               // price: parseInt(e.target.requestToman.value)
          }

          try {
               setLoading(true)
               await axios.put(PayWithdrawal(params.rejectId), putData)
               toast.success('اطلاعات پرداخت با موفقیت ثبت شد!')
          } finally { setLoading(false) }
     }


     return (
          <>
               <CheckoutNavbar />
               <div className="contentHolder">

                    <div className="row">
                         <div className="col-12">
                              <div className="box_radios">

                                   <div className="headHolder bordered"><p className="title">رد درخواست تسویه حساب</p></div>

                                   <div className="requestSettingForm" style={{ padding: '20px' }}>
                                        <form onSubmit={handleSubmitForm}>
                                             <p> <textarea name="rejectDetail" id="rejectDetail" cols="30" rows="5" placeholder='دلیل رد درخواست ...' defaultValue=''></textarea></p>

                                             {loading
                                                  ?
                                                  <p><button type="button" className='disabled' style={{ padding: '1rem 2rem' }}> لطفا صبر کنید...</button></p>
                                                  :
                                                  <p><input type="submit" value="ثبت" /></p>
                                             }
                                        </form>
                                   </div>

                              </div>
                         </div>
                    </div>
               </div>
          </>
     )
}

export default RejectRequest